import * as React from 'react';
import { Link } from "gatsby";
import { GatsbyImage, getImage } from "gatsby-plugin-image";

export default function PostCard({ postData }) {
  const post = postData;
  const title = post.node.title
            //const image = post.node.featuredImage.gatsbyImageData
            const image = getImage(post.node.media)

            return (
              <li key={post.node.slug}>
                <article
                  className="post-list-item"
                  itemScope
                  itemType="http://schema.org/Article"
                >
                   <header className="post-list-item-top">
                    {/* <GatsbyImage image={image} alt="" /> */}
                    
                    <h2>
                      <Link to={`../${post.node.slug}`} itemProp="url">
                        <span itemProp="headline">{title}</span>
                      </Link>
                    </h2>
                  </header>
                  <div className="post-list-item-summary">
                    <section>
                      <p>
                        {post.node.summary.summary}
                      </p>
                    </section>
                  </div>
                  
                   {image && <div className="post-list-item-image">
                    {/* <Link to={post.node.slug}> */}
                  <GatsbyImage image={image} alt="" className="post-list-image"/>
                    {/* </Link> */}
                  </div>
                    }
                  <div className="post-list-item-category-date">
                    <div style={{display: "flex"}}>
                      <div className="post-list-item-date">{post.node.date}</div>
                      <div className="category-date-separator">·</div>
                      <Link to={`../${post.node.category[0].toLowerCase()}`}><div className="post-list-item-category">{post.node.category[0]}</div></Link>
                    </div>
                    <Link to={`../${post.node.slug}`} className="post-list-item-read-more-link">
                    <div className="post-list-item-read-more">Read More →</div>
                    </Link>
                  </div>
                </article>
              </li>
            );
}

